export default __webpack_public_path__ + "static/media/TERMO_DE_USO_E_POLITICA_DE_PRIVACIDADE.d8d77044.pdf";